import React from "react";

// // Layouts
import AuthLayout from "./layouts/Auth";
import DashboardLayout from "./layouts/Dashboard";
import LandingLayout from "./layouts/Landing";

// // Guards
import AuthGuard from "./components/guards/AuthGuard";

// // Pages
import AdsList from "./pages/ads/AdsList";
import AdsIndex from "./pages/ads/Index";

import Landing from "./pages/landing/Landing";

import SettingsProfile from "./pages/settings/Profile";
import SettingsIndex from "./pages/settings/Index";
import Alerts from "./pages/settings/Alerts";
import Subscription from "./pages/settings/Subscription";

import AlertsList from "./pages/alerts/AlertsList";
import AlertsMessages from "./pages/alerts/Messages";

// // Auth
import Page500 from "./pages/auth/Page500";
import Page404 from "./pages/auth/Page404";
import SignIn from "./pages/auth/SignIn";
import TokenSignIn from "./pages/auth/TokenSignIn";
import SignOut from "./pages/auth/SignOut";
import Register from "./pages/auth/Register";

import Dashboard from "./pages/dashboard/Dashboard";

const routes = [
  {
    path: "/",
    element: <LandingLayout />,
    children: [
      {
        path: "",
        element: <Landing />,
      },
    ],
  },
  {
    path: "dash",
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: "",
        element: <Dashboard />,
      },
    ],
  },
  {
    path: "ads",
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: "",
        element: <AdsIndex />,
      },
      {
        path: "list/:listId",
        element: <AdsList />,
      },
    ],
  },
  {
    path: "alerts",
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: "",
        element: <AlertsList />,
      },
      {
        path: "list/:listId",
        element: <AlertsList />,
      },
      {
        path: "messages",
        element: <AlertsMessages />,
      },
    ],
  },
  {
    path: "settings",
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: "",
        element: <SettingsIndex />,
      },
      {
        path: "alerts",
        element: <Alerts />,
      },
      {
        path: "profile",
        element: <SettingsProfile />,
      },
      {
        path: "subscription",
        element: <Subscription />,
      },
    ],
  },
  {
    path: "auth",
    element: <AuthLayout />,
    children: [
      {
        path: "sign-in",
        element: <SignIn />,
      },
      {
        path: "sign-out",
        element: <SignOut />,
      },
      {
        path: "token/:token",
        element: <TokenSignIn />,
      },
      {
        path: "404",
        element: <Page404 />,
      },
      {
        path: "500",
        element: <Page500 />,
      },
      {
        path: "register/:code",
        element: <Register />,
      },
    ],
  },
  {
    path: "*",
    element: <AuthLayout />,
    children: [
      {
        path: "*",
        element: <Page404 />,
      },
    ],
  },
];

export default routes;
